import { forwardRef } from "react";

import { SinglePhotoPicker } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormSinglePhotoPickerProps } from "../../types";

export const FormSinglePhotoPicker = forwardRef<HTMLInputElement, FormSinglePhotoPickerProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <SinglePhotoPicker ref={ref} {...props} />
  </FormField>
));

FormSinglePhotoPicker.displayName = "Form.SinglePhotoPicker";
